import styled from 'styled-components';

import { Colors } from 'modules/ui/theme/colors';

export const ChartCard = styled.div`
  background-color: ${Colors.White};
  border: 1px solid ${Colors.Gray};
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(1, 7, 36, 0.08);
  padding: 16px;
  margin: 16px 20px;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(1, 7, 36, 0.12);
  }
`;
